var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navbar'),_c('vue-headful',{attrs:{"title":"USED CODE"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }